module.exports = __webpack_public_path__ + "warn.png";